import { BusStop, LogLocationType } from '@/types/logs'
import { parseLocationStopValue } from './location'

export const getSelectedStops = (
    allStops: BusStop[],
    from: string,
    to: string,
    locationType: LogLocationType
): BusStop[] => {
    const selectedFromIndex = allStops.findIndex((item) => {
        const { stopNumber, direction } = parseLocationStopValue(from)

        return item.stopNumber === stopNumber && item.direction === direction
    })
    const selectedToIndex = allStops.findIndex((item) => {
        const { stopNumber, direction } = parseLocationStopValue(to)

        return item.stopNumber === stopNumber && item.direction === direction
    })

    if (selectedFromIndex === -1 && selectedToIndex === -1) {
        return []
    }

    if (selectedFromIndex !== -1 && selectedToIndex == -1) {
        return [allStops.at(selectedFromIndex) as BusStop]
    }

    if (selectedFromIndex == -1 && selectedToIndex !== -1) {
        return [allStops.at(selectedToIndex) as BusStop]
    }

    const fromStop = allStops[selectedFromIndex]
    const toStop = allStops[selectedToIndex]
    let selectedStopsRange = []

    if (fromStop.direction === 'inbound' && toStop.direction === 'outbound') {
        selectedStopsRange = [...allStops.slice(0, selectedToIndex + 1), ...allStops.slice(selectedFromIndex)]
    } else {
        const [fromIndex, toIndex] = [
            Math.min(selectedFromIndex, selectedToIndex),
            Math.max(selectedFromIndex, selectedToIndex),
        ]

        selectedStopsRange = allStops.slice(fromIndex, toIndex + 1)
    }

    return locationType === LogLocationType.All
        ? selectedStopsRange
        : selectedStopsRange.filter((stop) => stop.isCurtailmentStop)
}
